import React, { useEffect, useRef, useState } from 'react'
import { isMobile } from 'react-device-detect'
import { useNavigate } from 'react-router-dom'
import styled from 'styled-components'
import { IssuableAllCouponType } from '../../@types/coupon'
import { getIssuableAllCoupon, postCouponNoDownload } from '../../api/coupons'
import { useMyContext } from '../../components/provider/MyProvider'
import CouponCenterSort from '../../components/myshopping/CouponCenterSort'
import CouponCenterSubmit from '../../components/myshopping/CouponCenterSubmit'
import CouponModalCenter from '../../components/myshopping/CouponModalCenter'
import CouponSort from '../../components/myshopping/CouponSort'
import CouponSubmit from '../../components/myshopping/CouponSubmit'
import MyShoppingSideBar from '../../components/myshopping/MyShoppingSideBar'
import { useCommonContext } from '../../components/provider/CommonProvider'
import { IconCouponComplete, IconDownload } from '../../components/svg/IconSvg'
import { PageTitle } from '../../components/title/PageTitle'
import '../../css/Coupon.css'
import '../../css/myshopping.css'
import { plusComma } from '../../js/script'
import { AFWebLinkType, RNPostMessage } from '../../js/postMessage'
import { useAppContext } from '../../components/provider/AppProvider'

// 이미지 경로
const imgURL = '/images'

export default function Coupon() {
  const [items, setItems] = useState<IssuableAllCouponType[]>([])
  const [submitItem, setSubmitItem] = useState<IssuableAllCouponType[]>([])
  const [submitItems, setSubmitItems] = useState<IssuableAllCouponType[]>([])
  const [couponSortModal, setCouponSortModal] = useState<boolean>(false)
  const [sortKeyword, setSortKeyword] = useState<string>('최신순')
  const [submitModal, setSubmitModal] = useState<boolean>(false)
  const [submitKeyword, setSubmitKeyword] = useState<string>('전체')
  const [submitSort, setSubmitSort] = useState<IssuableAllCouponType[]>([])
  const [checkIssuable, setCheckIssuable] = useState<boolean>(false)
  const [isSortIcon, setIsSortIcon] = useState<boolean>(false)
  const [isCouponTypeModal, setIsCouponTypeModal] = useState<boolean>(false)
  const [isCouponSortModal, setIsCouponSortModal] = useState<boolean>(false)
  const [downloadable, setDownloadable] = useState<IssuableAllCouponType[]>([])
  const btnCouponRef = useRef<any>(null)
  const btnCouponSortRef = useRef<any>(null)
  const { setIsLottie } = useCommonContext()
  // 다운가능한 모든 쿠폰
  useEffect(() => {
    getIssuableAllCoupon()
      .then((res) => setItems(res.data))
      .catch((err) => console.log(err))
  }, [checkIssuable, location.pathname])

  useEffect(() => {
    const filteredItems = submitSort.filter((el: any) => el.couponName !== '어바웃피싱 페이 감사 쿠폰')
    setSubmitItems(filteredItems)
  }, [submitSort])
  // 다운가능한 상품
  useEffect(() => {
    const downloadableItems = submitItems.filter((el: any) => el.downloadable)
    setDownloadable(downloadableItems)
  }, [submitItems])
  // 쿠폰 조건으로 정렬
  useEffect(() => {
    if (submitKeyword === '전체') {
      setSubmitItem(items)
      setIsLottie(false)
    } else {
      const filteredItems = items.filter((el: any) => {
        if (submitKeyword === '상품쿠폰') {
          return el.couponType === 'CART'
        } else if (submitKeyword === '주문쿠폰') {
          return el.couponType === 'PRODUCT'
        }
        return false
      })
      setSubmitItem(filteredItems)
    }
  }, [submitModal, items, checkIssuable, submitKeyword])
  //쿠폰 정렬
  useEffect(() => {
    if (sortKeyword === '할인률순') {
      const sortedProducts = [...submitItem].sort(
        (a: any, b: any) => (b.discountInfo?.discountAmt || 0) - (a.discountInfo?.discountAmt || 0)
      )
      setSubmitSort(sortedProducts)
    } else if (sortKeyword === '최신순') {
      const sortedProducts = [...submitItem].sort(
        (a: any, b: any) => (b.dateInfo?.issueStartYmdt || 0) - (a.dateInfo?.issueStartYmdt || 0)
      )
      setSubmitSort(sortedProducts)
    }
  }, [sortKeyword, submitItem, submitKeyword])

  return (
    <>
      <div className='main_wrap'>
        <div
          className={
            isMobile
              ? submitItem.length === 0
                ? 'contents_wrap full'
                : 'contents_wrap'
              : 'contents_wrap sidemenu_wrap full'
          }
        >
          <MyShoppingSideBar />
          <div className='myshopping_wrap'>
            <PageTitle>쿠폰 받기</PageTitle>

            <div className='coupon_wrap'>
              {/* 쿠폰 목록 헤더 */}
              <div className='coupon_header'>
                <p>
                  <em>{downloadable.length}</em>개의 쿠폰
                </p>
                <div className='btn_box'>
                  <button
                    type='button'
                    ref={btnCouponRef}
                    onClick={() => {
                      setIsCouponTypeModal((prev) => !prev)
                      setIsSortIcon(!isSortIcon)
                      setSubmitModal(true)
                    }}
                  >
                    {submitKeyword}
                    {!isMobile && isCouponTypeModal ? (
                      <img src={`${imgURL}/icon_arrow_up.png`} alt='' />
                    ) : (
                      <img src={`${imgURL}/icon_arrow_down.png`} alt='' />
                    )}
                    {!isMobile && isCouponTypeModal ? (
                      <CouponCenterSubmit
                        isModal={isCouponTypeModal}
                        setIsModal={setIsCouponTypeModal}
                        submitKeyword={submitKeyword}
                        setSubmitKeyword={setSubmitKeyword}
                        setIsSortIcon={setIsSortIcon}
                        btnCouponRef={btnCouponRef}
                      ></CouponCenterSubmit>
                    ) : null}
                  </button>
                  <i></i>
                  <button
                    ref={btnCouponSortRef}
                    type='button'
                    onClick={() => {
                      setIsCouponSortModal((prev) => !prev)
                      setIsSortIcon(!isSortIcon)
                      setCouponSortModal((prev) => !prev)
                      setCouponSortModal(true)
                    }}
                  >
                    {sortKeyword}
                    {!isMobile && isCouponSortModal ? (
                      <img src={`${imgURL}/icon_arrow_up.png`} alt='' />
                    ) : (
                      <img src={`${imgURL}/icon_arrow_down.png`} alt='' />
                    )}
                    {isCouponSortModal
                      ? !isMobile && (
                          <CouponCenterSort
                            isModal={isCouponSortModal}
                            setIsModal={setIsCouponSortModal}
                            sortKeyword={sortKeyword}
                            setSortKeyword={setSortKeyword}
                            setIsSortIcon={setIsSortIcon}
                            btnCouponSortRef={btnCouponSortRef}
                          ></CouponCenterSort>
                        )
                      : null}
                  </button>
                </div>
              </div>
              {/* 쿠폰 받기 목록 */}

              {downloadable.length !== 0 ? (
                <div className='coupon_list'>
                  {downloadable?.map((el: any) => {
                    return (
                      <CouponItem
                        el={el}
                        setCheckIssuable={setCheckIssuable}
                        checkIssuable={checkIssuable}
                        // setToastMessage={setToastMessage}
                      ></CouponItem>
                    )
                  })}
                </div>
              ) : (
                <NoContentWrap>
                  <NoContentCotentWrap2>
                    <img src='/images/empty_logo.png' alt='' />
                    <NoContentContent>다운로드 가능한 쿠폰이 없습니다.</NoContentContent>
                  </NoContentCotentWrap2>
                </NoContentWrap>
              )}
            </div>
          </div>
          {/* 쿠폰 종류 */}
          {submitModal && isMobile ? (
            <CouponSubmit
              setIsModal={setSubmitModal}
              submitKeyword={submitKeyword}
              setSubmitKeyword={setSubmitKeyword}
            ></CouponSubmit>
          ) : null}
          {/* 최신순, 할인률 */}
          {couponSortModal ? (
            isMobile ? (
              <CouponSort
                setIsModal={setCouponSortModal}
                headerText={'정렬'}
                sortKeyword={sortKeyword}
                setSortKeyword={setSortKeyword}
              ></CouponSort>
            ) : null
          ) : null}
        </div>
      </div>
    </>
  )
}

export function CouponItem({ el, setCheckIssuable, checkIssuable }: any) {
  const [donwCheck, setDownCheck] = useState(true)
  const [couponModalCenter, setcouponModalCenter] = useState(false)
  const [selectCouponNo, setSelectCouponNo] = useState<number>()

  const { isAppView } = useAppContext()
  const { isToast, setToastMessage, setToastBtnMessage, setToastEvent, setIsToast } = useMyContext()
  const { setIsLottie } = useCommonContext()

  const navigate = useNavigate()

  function downloadCoupon(couponNo: number) {
    postCouponNoDownload(couponNo)
      .then((res) => {
        setIsToast(true)
        setToastMessage('쿠폰이 발급되었습니다. 사용가능한 쿠폰에서 확인해 보세요.')
        setToastBtnMessage('바로가기')
        setToastEvent(() => {
          if (isAppView) {
            RNPostMessage(AFWebLinkType.moveToLink, {
              url: `aboutfishing://aboutfishing.com/?page=webview&url=${process.env.REACT_APP_SHOP_URL}/mycoupon`,
            })
          } else {
            navigate(`/mycoupon`)
          }
        })
        setIsLottie(false)
        setCheckIssuable((prev: boolean) => !prev)
      })
      .catch((err) => console.log(err))
  }

  useEffect(() => {
    if (Number(el.couponStatus.myIssuedCnt) === Number(el.issueConstraint.dailyIssuePerPersonLimitCnt)) {
      setDownCheck(false)
    } else {
      setDownCheck(true)
    }
    if (Number(el.couponStatus.myIssuedCnt) === Number(el.issueConstraint.issuePerPersonLimitCnt)) {
      setDownCheck(false)
    } else {
      setDownCheck(true)
    }
  }, [el, checkIssuable])

  return (
    <>
      {' '}
      <div className='coupon_item'>
        <div className='f_box'>
          <em>
            {el.dateInfo?.issueStartYmdt.split(' ', 1).join('').replaceAll('-', '. ').replaceAll('. 0', '. ')} -{' '}
            {el.dateInfo?.issueEndYmdt.split(' ', 1).join('').replaceAll('-', '. ').replaceAll('. 0', '. ')}
          </em>
          <p>{el.couponName}</p>
          <span>
            최대{' '}
            {!el.discountInfo?.discountRate
              ? `${plusComma(el.discountInfo?.discountAmt)}원 할인`
              : `${plusComma(el.discountInfo?.maxDiscountAmt)}원 할인`}
          </span>
          <div>
            <strong>
              {' '}
              {el.discountInfo?.discountRate
                ? `${el.discountInfo?.discountRate}%`
                : `${plusComma(el.discountInfo?.discountAmt)}원`}
            </strong>
            <button
              type='button'
              onClick={() => {
                setcouponModalCenter(true)
                setSelectCouponNo(el.couponNo)
              }}
            >
              사용안내
            </button>
          </div>
        </div>
        {el.downloadable ? (
          <button
            type='button'
            onClick={() => {
              setIsLottie(true)
              downloadCoupon(el.couponNo)
            }}
            key={el.couponNo}
          >
            <span>
              쿠폰 발급받기
              <IconDownload width={20} height={20} color='var(--colWhite)' />
            </span>
          </button>
        ) : (
          <button type='button' className='off' key={el.couponNo}>
            <span>
              쿠폰 발급완료
              <IconCouponComplete width={20} height={20} color='var(--colGray5)' />
            </span>
          </button>
        )}
      </div>
      {couponModalCenter ? (
        <CouponModalCenter
          setIsModal={setcouponModalCenter}
          item={[el]}
          selectCouponNo={selectCouponNo}
        ></CouponModalCenter>
      ) : null}
    </>
  )
}
export const NoContentWrap = styled.div`
  flex: 1;
  display: flex;
  justify-content: center;
  width: 100%;
  height: 100%;

  @media screen and (min-width: 768px) {
    display: flex;
    padding: 0;
    height: 100%;
    justify-content: center;
    align-items: center;
  }
`
export const NoContentContent = styled.p`
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
  color: var(--colGray5);
  text-align: center;
  margin-bottom: 20px;
  @media screen and (min-width: 768px) {
    font-size: 20px;
    font-weight: 500;
    line-height: 32px;
  }
`
export const NoContentCotentWrap2 = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 120px 0 160px 0;
  & img {
    width: 85px;
    height: 85px;
  }
  @media screen and (min-width: 768px) {
    & img {
      width: 108px;
      height: 108px;
    }
  }
`
